import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

import React, { useEffect } from "react"
import Lenis from "@studio-freight/lenis"
import { navigate } from "gatsby"

const WrapWithLenis = ({ element }) => {
    useEffect(() => {
        if (typeof window !== "undefined") {
            const lenis = new Lenis({
                duration: 1.2, // 慣性スクロールの強さ
                smooth: true,
            })

            function raf(time) {
                lenis.raf(time)
                requestAnimationFrame(raf)
            }
            requestAnimationFrame(raf)

            return () => {
                lenis.destroy()
            }
        }
    }, [])

    return <>{element}</>
}


export const onRouteUpdate = ({ location }) => {
     // location.pathname の末尾 / を削除して正規化
    const path = location.pathname.replace(/\/$/, "");

    // リダイレクト対象ページ
    if (
        path === "/recruit02" ||
        path === "/recruit04" ||
        path === "/recruit05" ||
        path === "/recruit06" ||
        path === "/recruit07" ||
        path === "/recruit08" ||
        path === "/recruit09" ||
        path === "/recruit10"
    ) {
        navigate("/", { replace: true }); // ホームにリダイレクト
    }

    if (typeof document !== "undefined") {
        const elements = document.querySelectorAll(".fadeInUp");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("on");
                    }
                });
            },
            { threshold: 0.1 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => {
            elements.forEach((el) => observer.unobserve(el));
        };
    }
};

export const wrapPageElement = ({ element }) => {
    return <WrapWithLenis element={element} />
}